module.exports = __webpack_public_path__ + "static/media/fortepiano.11f640a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fortepiano.svg?lxkk5l
// module id = 564
// module chunks = 0